/**
 * RebookReasonField — the required "why" on a rebook (BON-146). Saved to BOTH
 * bookings' history, which the help text says out loud: a CSR who thinks this
 * is a private note writes differently from one who knows two audit trails will
 * quote it.
 */
export interface RebookReasonFieldProps {
  value: string;
  onChange: (v: string) => void;
  error: string | null;
  inputRef: React.RefObject<HTMLTextAreaElement>;
}

export function RebookReasonField({ value, onChange, error, inputRef }: RebookReasonFieldProps) {
  return (
    <div>
      <label
        htmlFor="rebook-reason"
        className="block text-sm font-semibold text-bark-900 dark:text-stone-100"
      >
        Reason <span className="text-red-600">*</span>
      </label>
      <textarea
        id="rebook-reason"
        ref={inputRef}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={3}
        maxLength={500}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? 'rebook-reason-error rebook-reason-help' : 'rebook-reason-help'}
        placeholder="Why is this booking being moved? Whatever the customer told you."
        className="mt-1.5 w-full rounded-lg border border-stone-300 px-3 py-2 text-sm dark:border-stone-600 dark:bg-[#1e2520] dark:text-stone-100"
      />
      <p id="rebook-reason-help" className="mt-1.5 text-xs text-stone-500 dark:text-stone-400">
        Saved to both bookings&rsquo; history for staff. The customer never sees it.
      </p>
      {/* role="alert" so the failure is announced rather than silently
          appearing, and tied to the field via aria-describedby above. */}
      {error && (
        <p id="rebook-reason-error" role="alert" className="mt-1.5 text-sm text-red-600">
          {error}
        </p>
      )}
    </div>
  );
}
